export default {
    computed: {
        isReadOnlyAccess() {
            return this.$store.getters['logInModule/searchState']?.profile?.readOnlyAccess == 1;
        }
    },

    methods: {
        ensureWriteAccess() {
            if (this.isReadOnlyAccess) {
                this.showToast("error", "Read Only Access", "Your profile only allows viewing this screen.");
                return false;
            }

            return true;
        }
    }
}
